import { observer } from 'mobx-react-lite';
import {
  Button,
  PasswordField,
  SavingIndicator,
  TextField,
  Widget,
  WidgetFooter,
} from '../../../components';
import Shopify from '../store/services/webhooks/Shopify';
import Webhooks from '../store/services/webhooks/Webhooks';

export default observer(function ShopifyForm({
  webhooks,
}: {
  webhooks: Webhooks;
}) {
  const items = webhooks.selectedServices;

  return (
    <>
      {items.map((webhook) => (
        <ItemForm
          canBeDeleted={items.length > 1}
          key={webhook.id}
          webhook={webhook as Shopify}
        />
      ))}

      <Button
        icon="plus"
        onClick={() => webhooks.addService('shopify')}
        sx={{ mt: 3 }}
        type="secondary"
      >
        Add another Shopify configuration
      </Button>
    </>
  );
});

const ItemForm = observer(function ItemForm({
  canBeDeleted,
  webhook,
}: {
  canBeDeleted: boolean;
  webhook: Shopify;
}) {
  return (
    <Widget surface="gray" sx={{ mt: 3 }}>
      <TextField
        errorText={webhook.errors.name}
        InputLabelProps={{ shrink: true }}
        label="Name"
        name="name"
        onBlur={webhook.handleBlur}
        onChange={webhook.handleChange}
        placeholder="Optional"
        sx={{ width: '80%' }}
        value={webhook.name}
      />
      <TextField
        errorText={webhook.errors.apiKey}
        label="API Key (optional)"
        name="apiKey"
        onBlur={webhook.handleBlur}
        onChange={webhook.handleChange}
        sx={{ width: '80%' }}
        value={webhook.apiKey}
      />
      <PasswordField
        errorText={webhook.errors.apiPassword}
        label="API Password (optional)"
        name="apiPassword"
        onBlur={webhook.handleBlur}
        onChange={webhook.handleChange}
        sx={{ width: '80%' }}
        value={webhook.apiPassword}
      />
      <TextField
        errorText={webhook.errors.locationId}
        label="Location ID"
        name="locationId"
        onBlur={webhook.handleBlur}
        onChange={webhook.handleChange}
        sx={{ width: 160 }}
        value={webhook.locationId}
      />
      <PasswordField
        errorText={webhook.errors.webhookSecret}
        label="Webhook Secret"
        name="webhookSecret"
        onBlur={webhook.handleBlur}
        onChange={webhook.handleChange}
        required
        sx={{ width: '80%' }}
        value={webhook.webhookSecret}
      />

      <WidgetFooter>
        {canBeDeleted && (
          <Button icon="trash" onClick={webhook.delete} type="secondary">
            Delete
          </Button>
        )}
        <SavingIndicator indicator={webhook.indicator} sx={{ mr: 2 }} />
      </WidgetFooter>
    </Widget>
  );
});
